let toggleCircleSections = document.querySelectorAll(
    ".section-toggle-circles "
);
toggleCircleSections.forEach((section) => {
    let toggle = section.querySelector(".toggle");

    toggle.addEventListener("click", function () {
        let isOpened = section.classList.contains("expanded");
        toggleCircleSections.forEach((s) => {
            let circles = s.querySelector(".circles");
            circles.style.height = 0;
            circles.style.opacity = 0;
            s.classList.remove("expanded");
        });

        if (!isOpened) {
            section.classList.add("expanded");
            let circles = section.querySelector(".circles");
            let inner = section.querySelector(".inner");

            circles.style.opacity = 1;
            circles.style.height = inner.offsetHeight + "px";
        }
    });
});
